import React, { createContext, useContext } from 'react';

interface AppContext {
  tabs: string[];
  selectedTabId: string;
  setSelectedTabId: React.Dispatch<React.SetStateAction<string>>;
  freeSearchText: string;
  setFreeSearchText: React.Dispatch<React.SetStateAction<string>>;
  lastTableUpdateTime: string;
  setLastTableUpdateTime: React.Dispatch<React.SetStateAction<string>>;
  applyPagination: boolean;
  setApplyPagination: React.Dispatch<React.SetStateAction<boolean>>;
}

export const appContext = createContext<AppContext>({
  tabs: ['1'],
  selectedTabId: '1',
  setSelectedTabId: () => alert('selecting Id'),
  freeSearchText: '',
  setFreeSearchText: () => alert('set'),
  lastTableUpdateTime: '',
  setLastTableUpdateTime: () => alert('set'),
  applyPagination: true,
  setApplyPagination: () => {},
});

export const AppProvider = appContext.Provider;

export const useAppContext = () => useContext(appContext);
